// https://bluebusbackened.onrender.com
import axios from 'axios';
export const axiosapi = axios.create({
    baseURL: 'https://bluebusbackened.onrender.com'
});
export const axiosPrivate = axios.create({
    baseURL: 'https://bluebusbackened.onrender.com',
    headers: { 'Content-type': 'application/json' },
    withCredentials: true

})